import React from "react"

import { InstallationReference } from "shared/types/InstallationReference"
import { ProductPositionInstallationReference } from "shared/types/__generated__/graphql"
import { Readonly } from "shared/ui/readonly/Readonly"

import { ProductPositionInstallationReferenceListItem } from "./ProductPositionInstallationReferenceListItem"
import "./styles/_product-position-installation-reference-list.scss"

interface ProductPositionInstallationReferenceListProps {
  productPositionInstallationReferences:
    | ProductPositionInstallationReference[]
    | null
    | undefined
  installationReferences: InstallationReference[] | null | undefined
  isEditing?: boolean
  isLoading?: boolean
  onDeleteInstallationReference?: (id: string) => void
}

export const ProductPositionInstallationReferenceList = React.memo(
  ({
    productPositionInstallationReferences,
    installationReferences,
    isEditing,
    isLoading,
    onDeleteInstallationReference
  }: ProductPositionInstallationReferenceListProps) => {
    if (isLoading) {
      return (
        <div className="product-position-install-ref-list">
          <div className="product-position-install-ref-list__item">
            <Readonly.Root
              isLoading
              className="product-position-install-ref-list__item-title"
            >
              <Readonly.Label />
              <Readonly.Value />
            </Readonly.Root>
          </div>
        </div>
      )
    }

    if (!productPositionInstallationReferences?.length) {
      return null
    }

    return (
      <div className="product-position-install-ref-list">
        {productPositionInstallationReferences.map(
          (productPositionInstallationReference, index) => {
            const installationReference = installationReferences?.find(
              i => i.id === productPositionInstallationReference.permalink
            )

            return (
              <ProductPositionInstallationReferenceListItem
                key={productPositionInstallationReference.id}
                namePrefix={`productPosition.references.${index}`}
                installationReference={installationReference}
                isEditing={isEditing}
                onDelete={
                  onDeleteInstallationReference
                    ? () =>
                        onDeleteInstallationReference(
                          productPositionInstallationReference.id
                        )
                    : undefined
                }
              />
            )
          }
        )}
      </div>
    )
  }
)
